import * as saleAction from './constants'
export const saleReportNvkdRequest = (formData) => {
  return {
    type: saleAction.SALE_REPORT_NVKD_REQUESTING,
    formData
  }
}

export const saleReportNvkdSuccess = (data) => {
  return {
    type: saleAction.SALE_REPORT_NVKD_SUCCESS,
    data
  }
}

export const saleReportNvkdError = (error) =>{
  return {
    type: saleAction.SALE_REPORT_NVKD_ERROR,
    error
  }
}
export const saleReportKhRequest = (formData) => {
  return {
    type: saleAction.SALE_REPORT_KH_REQUESTING,
    formData
  }
}

export const saleReportKhSuccess = (data) => {
  return {
    type: saleAction.SALE_REPORT_KH_SUCCESS,
    data
  }
}

export const saleReportKhError = (error) => {
  return {
    type: saleAction.SALE_REPORT_KH_ERROR,
    error
  }
}
export const saleReportKhoXuatRequest = (formData) => {
  return {
    type: saleAction.SALE_REPORT_KHOXUAT_REQUESTING,
    payload: formData
  }
}

export const saleReportKhoXuatSuccess = (data) => {
  return {
    type: saleAction.SALE_REPORT_KHOXUAT_SUCCESS,
    data
  }
}

export const saleReportKhoXuatError = (error) => {
  return {
    type: saleAction.SALE_REPORT_KHOXUAT_ERROR,
    error
  }
}
export const saleReportListRequest = (formData) => {
  return {
    type: saleAction.SALE_REPORT_LIST_REQUESTING,
    formData
  }
}

export const saleReportListSuccess = (data) => {
  return {
    type: saleAction.SALE_REPORT_LIST_SUCCESS,
    data
  }
}

export const saleReportListError = (error) => {
  return {
    type: saleAction.SALE_REPORT_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: saleAction.SALE_REPORT_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: saleAction.SALE_REPORT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: saleAction.SALE_REPORT_EXPORT_XLS_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/SaleReport/actions.js